import React from 'react';

interface FormContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  heading?: string | React.ReactNode | React.ReactNode[];
  disclaimer?: string | React.ReactNode | React.ReactNode[];
  children?: React.ReactNode;
  isSubmitted?: boolean;
  confirmation?: React.ReactNode;
  wrapperRef?: React.RefObject<HTMLDivElement>;
}

const FormContainer: React.FC<FormContainerProps> = ({
  className = '',
  heading,
  disclaimer,
  children,
  isSubmitted = false,
  confirmation,
  wrapperRef,
  ...otherProps
}) => {
  return (
    <div
      className={`mz-form-container ${isSubmitted ? 'submitted' : ''} ${className}`}
      ref={wrapperRef}
      {...otherProps}
    >
      {
        (confirmation && isSubmitted) && (
          <div className="mz-form-container__confirmation">
            {confirmation}
          </div>
        )
      }

      <div className="mz-form-container__inner">
        {heading && (
          <div className="mz-form-container__heading">
            {heading}
          </div>
        )}

        {children}

        {disclaimer && (
          <div className="mz-form-container__disclaimer label label--tight">
            {disclaimer}
          </div>
        )}
      </div>

    </div>
  );
};

export default FormContainer;
